import React, { useState } from "react";
import { Box, Button, Flex, Icon, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { MdEventAvailable, MdLink, MdHandyman } from "react-icons/md";
import Card from "horizon/components/card/Card";
import MarkPaidDialog from "./MarkPaidDialog";
import SendPaymentLinkDialog from "./SendPaymentLinkDialog";
import PaymentPanelHeader from "./PaymentPanelHeader";

/**
 * Reusable action card used to surface a single manual operation.
 * @param {Object} props - { icon, title, description, ctaLabel, onClick }
 * @returns {React.ReactElement}
 */
function ActionCard({ icon, title, description, ctaLabel, onClick }) {
    const cardBg = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    const descColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Box flex="1" p="16px" borderRadius="16px" bg={cardBg}>
            <Flex align="center" gap="12px" mb="8px">
                <Icon as={icon} w="22px" h="22px" color="brand.500" />
                <Text fontSize="md" fontWeight="600" color={titleColor}>{title}</Text>
            </Flex>
            <Text fontSize="sm" color={descColor} mb="16px">{description}</Text>
            <Button onClick={onClick} colorScheme="brand" size="sm">{ctaLabel}</Button>
        </Box>
    );
}

/**
 * Manual actions panel with two cards (mark paid + send commercial link).
 * @returns {React.ReactElement}
 */
function ManualActionsPanel() {
    const [markOpen, setMarkOpen] = useState(false);
    const [linkOpen, setLinkOpen] = useState(false);
    return (
        <Card>
            <PaymentPanelHeader icon={MdHandyman} title="Actions manuelles"
                subtitle="Cas de bord nécessitant une intervention humaine" />
            <Stack direction={{ base: "column", md: "row" }} spacing="16px" align="stretch">
                <ActionCard icon={MdEventAvailable} title="Marquer une réservation comme payée"
                    description="À utiliser quand un virement SEPA est reçu mais que le webhook Stripe ne nous a pas notifié. La réservation passera en PAID et le mail de confirmation sera envoyé."
                    ctaLabel="Ouvrir le formulaire" onClick={() => setMarkOpen(true)} />
                <ActionCard icon={MdLink} title="Générer un lien de paiement commercial"
                    description="Pour les ventes B2B hors plateforme. Génère un Stripe Checkout, l'URL est renvoyée à transmettre au client. Le webhook flaguera la transaction en PAID automatiquement."
                    ctaLabel="Créer un lien" onClick={() => setLinkOpen(true)} />
            </Stack>
            <MarkPaidDialog open={markOpen} onClose={() => setMarkOpen(false)} />
            <SendPaymentLinkDialog open={linkOpen} onClose={() => setLinkOpen(false)} />
        </Card>
    );
}

export default ManualActionsPanel;
